import React from 'react';
import { useAppSelector } from '../../store/hooks';
import { CText } from '../common';
import { FiZap, FiCheck } from 'react-icons/fi';

interface UpgradeBannerProps {
  onUpgradeClick?: () => void;
  subscriptionTier?: 'free' | 'pro' | 'premium';
}

const UpgradeBanner: React.FC<UpgradeBannerProps> = ({
  onUpgradeClick,
  subscriptionTier = 'free',
}) => {
  const colors = useAppSelector((state) => state.theme.theme);

  // Don't show banner for paid users
  if (subscriptionTier !== 'free') {
    return null;
  }

  const benefits = ['Unlimited AI queries', 'All buckets', 'Expert discounts'];

  return (
    <div
      className="fixed bottom-4 left-0 right-0 mx-4 lg:mx-auto lg:max-w-md p-4 rounded-2xl z-40 animate-fade-in-up"
      style={{
        background: `linear-gradient(135deg, ${colors.primary}, #9F03F2)`,
        boxShadow: '0 -4px 20px rgba(107, 57, 244, 0.4)',
      }}
    >
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            {React.createElement(FiZap as any, { size: 18, color: '#fff' })}
            <CText type="M14" color="#fff" style={{ fontWeight: 700 }}>
              Upgrade to Pro - Rs.499/month
            </CText>
          </div>
          <div className="flex flex-wrap gap-x-3 gap-y-1">
            {benefits.map((benefit, idx) => (
              <div key={idx} className="flex items-center gap-1">
                {React.createElement(FiCheck as any, { size: 12, color: 'rgba(255,255,255,0.8)' })}
                <CText type="r10" color="rgba(255,255,255,0.9)">
                  {benefit}
                </CText>
              </div>
            ))}
          </div>
        </div>
        <button
          onClick={onUpgradeClick}
          className="ml-3 px-4 py-2 rounded-xl font-semibold text-sm transition-all duration-200 hover:scale-105 active:scale-95"
          style={{
            backgroundColor: '#fff',
            color: colors.primary,
            boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
          }}
        >
          Start Free Trial
        </button>
      </div>
    </div>
  );
};

export default UpgradeBanner;
